// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"a2e9f10a","310":"a1eaa333","644":"d5f985fa"}[chunkId] + ".chunk.css";
};